import { Button } from '@mui/material';
import { setPlayerTeam, addPlayerToTeam } from 'redux/slices';
import { useSelector, useDispatch } from 'react-redux';
import { getPlayerPoints } from '../utils/points';

const queueOrder = (a, b) => (b.waitingFor - a.waitingFor)
  || ((b.checkedInNow ? 1 : 0) - (a.checkedInNow ? 1 : 0));

export function GenerateTwoTeamsBtn() {
  const players = useSelector((state) => state.players);
  const playersPerTeam = useSelector((state) => state.game.playersPerTeam);
  const dispatch = useDispatch();

  const generateTwoTeams = () => {
    // Quem entra respeita a ordem da fila; os pontos (totalPoints) só equilibram os dois times.
    const selected = players
      .filter((player) => player.checkedIn && player.teamId === 0)
      .sort(queueOrder)
      .slice(0, playersPerTeam * 2)
      .sort((a, b) => getPlayerPoints(b) - getPlayerPoints(a));

    // Distribuição em serpentina (A, B, B, A, A, B...): ninguém fica sempre com o melhor do par.
    const teamA = [];
    const teamB = [];
    selected.forEach((player, index) => {
      const prefersA = index % 4 === 0 || index % 4 === 3;
      if ((prefersA && teamA.length < playersPerTeam) || teamB.length >= playersPerTeam) {
        teamA.push(player);
      } else {
        teamB.push(player);
      }
    });

    teamA.forEach((player) => {
      dispatch(setPlayerTeam({ playerId: player.playerId, teamId: 1 }));
      dispatch(addPlayerToTeam({ playerId: player.playerId, teamId: 1 }));
    });
    teamB.forEach((player) => {
      dispatch(setPlayerTeam({ playerId: player.playerId, teamId: 2 }));
      dispatch(addPlayerToTeam({ playerId: player.playerId, teamId: 2 }));
    });
  };

  return <Button variant="contained" color="secondary" onClick={generateTwoTeams}>Gerar 2 times</Button>;
}
